/*
 * Types broadly use throughout the entire app
 */
import { Core, Feature } from "@minicity/core";
import { isFeatureEnabled, isNetworkAdmin } from "./session";
import { STATIC_CONFIG } from "./config";
export const isEntityManagedByMe = (entityType) => {
    if (isNetworkAdmin() || STATIC_CONFIG.SERVICE_ONLY_MODE)
        return true;
    // Online SS applications are always self-managed
    if (entityType == Core.EntityType['Online Social Security'])
        return true;
    // Partner users manage applications only if the NETWORK_PROCESSES_APPLICATIONS feature is disabled - unless in Service Only mode!
    if ([
        Core.EntityType['Georgia DFCS Benefits'],
        Core.EntityType['Social Security'],
        Core.EntityType['Birth Record']
    ].includes(entityType))
        return !isFeatureEnabled(Feature.Type.NETWORK_PROCESSES_APPLICATIONS);
    // Partner users don't manage anything else
    return false;
};
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["OPEN"] = "OPEN";
    TaskStatus["REVIEW_REQUIRED"] = "REVIEW_REQUIRED";
    TaskStatus["COMPLETED"] = "COMPLETED";
    TaskStatus["CANCELLED"] = "CANCELLED";
})(TaskStatus || (TaskStatus = {}));
export const taskStatusLabels = {
    [TaskStatus.OPEN]: "Open",
    [TaskStatus.REVIEW_REQUIRED]: "Under Review",
    [TaskStatus.COMPLETED]: "Completed",
    [TaskStatus.CANCELLED]: "Cancelled",
};
export const TaskType = {
    "Task": "CUSTOM",
    "Review Required": "MANUAL_REVIEW",
    "Notarization Required": "NOTARY",
    "Amendment / Correction Required": "AMENDMENT",
    "Submission": "SUBMISSION",
    "Delivery": "DELIVERY",
    "LIFT 2.0 - TB Testing": "LIFT_2_0_TB_TESTING",
    "LIFT 2.0 - Upload TB Test To HMIS": "LIFT_2_0_TB_TESTING_HMIS_ENTRY",
    "LIFT 2.0 - Order Birth Record": "LIFT_2_0_BIRTH_RECORD_ORDER",
    "LIFT 2.0 - Upload Birth Record To HMIS": "LIFT_2_0_BIRTH_RECORD_HMIS_ENTRY",
    "LIFT 2.0 - Order Social Security Card": "LIFT_2_0_SOCIAL_SECURITY_ORDER",
    "LIFT 2.0 - Upload Social Security Card To HMIS": "LIFT_2_0_SOCIAL_SECURITY_HMIS_ENTRY",
    "LIFT 2.0 - Order State ID": "LIFT_2_0_STATE_ID_ORDER",
    "LIFT 2.0 - Obtain Approved State ID": "LIFT_2_0_STATE_ID_RECEIVE",
    "LIFT 2.0 - Upload State ID To HMIS": "LIFT_2_0_STATE_ID_HMIS_ENTRY",
    "LIFT 2.0 - Achieve Full Document Readiness": "LIFT_2_0_DOCUMENT_READINESS",
    "LIFT 2.0 - Record Program Exit In HMIS": "LIFT_2_0_PROGRAM_EXIT",
};
export const TaskAudience = {
    "Mini City Admin": "NETWORK_USER",
    "Case Worker": "PARTNER_USER",
};
export const isTaskAssignedToMe = (t) => {
    if (isNetworkAdmin())
        return t.audience == "NETWORK_USER" || t.status == TaskStatus.REVIEW_REQUIRED;
    return t.audience == "PARTNER_USER";
};
export const doINeedToActionTask = (t) => {
    if (!isTaskAssignedToMe(t))
        return false;
    if (isNetworkAdmin() && t.status == TaskStatus.REVIEW_REQUIRED)
        return true;
    return t.status == TaskStatus.OPEN;
};
